import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components-new/icon/icon';
import Icon from 'components-new/icon/icon';
import Typography from 'components-new/typography/typography';

export interface BannerProps {
  title: string;
  variant:
    | 'primary'
    | 'neutral'
    | 'neutral-var'
    | 'warning'
    | 'warning-var'
    | 'success'
    | 'destructive';
  iconProps?: IconProps;
  className?: string;
  typographyClassName?: string;
}

const styles = {
  destructive: 'text-destructive-500 bg-destructive-100',
  neutral: 'text-accent-500 bg-accent-100',
  'neutral-var': 'text-neutral-500 bg-neutral-100',
  primary: 'text-primary-500 bg-primary-100',
  success: 'text-success-500 bg-success-100',
  warning: 'text-notice-500 bg-notice-100',
  'warning-var': 'text-warning-500 bg-warning-100',
};

const Banner = React.forwardRef<HTMLDivElement, BannerProps>((props, ref) => {
  const {
    title,
    variant,
    iconProps,
    className,
    typographyClassName,
    ...other
  } = props;

  const bannerClassName = twMerge(
    'flex flex-row items-center gap-1',
    'rounded px-1.5 py-0.5',
    styles[variant],
    className,
  );

  const titleClassName = twMerge(
    'font-semibold text-center pointer-events-none',
    typographyClassName,
  );
  const iconClassNames = twMerge(variant === 'neutral' && 'text-gray400');

  return (
    <div className={bannerClassName} ref={ref} {...other}>
      {iconProps && (
        <Icon className={iconClassNames} size={11} {...iconProps} />
      )}
      <Typography variant="ui-banner" as="p" className={titleClassName}>
        {title}
      </Typography>
    </div>
  );
});

Banner.displayName = 'Banner';

export default Banner;
